import { request } from '@umijs/max';
import type { LoginParams } from './type';

/** 登录接口 POST /login */
export async function login(params: LoginParams) {
  return request('/system/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/**
 * 退出登录 POST /logout
 * @param token 调用方在清除本地 token 前捕获的原 token；
 *   请求拦截器只认 localStorage，等它异步执行时 token 可能已被清掉，必须显式传入。
 * 失败静默（skipErrorHandler）：登出接口报 401 等错误不应触发全局"登录已失效"弹窗。
 */
export async function logout(token?: string | null) {
  return request('/logout', {
    method: 'POST',
    skipErrorHandler: true,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
}

interface ChangePwdParams {
  newPassword: string;
  oldPassword: string;
  /** 后端非空时校验与 newPassword 一致 */
  confirmPassword?: string;
}

// 修改密码 PUT /system/sysUser/password(userId 从登录态取)
export async function changePwd(data: ChangePwdParams) {
  return request('/system/sysUser/password', {
    method: 'PUT',
    data,
  });
}
